/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface IOperandScope extends IValueOperationScope {
        operandIndex: number;
        allowableVariableTypes: Array<Wars.Domain.Model.Codes.Enums.VariableType>;
        allowTimeDurationUi: boolean;
        allowableOperandTypes: models.CalculationType[];
    }

    export class Operand implements IDirective {
        public restrict: string = 'E';
        public controller = ['$scope', '$compile', '$http', '$templateCache', 'calculationService', OperandController];
        public controllerAs = 'controller';
        public scope: boolean = true; // False is use parents scope - True is create inherited scope from parents scope

        public link($scope: IOperandScope, element: JQuery, attrs: ng.IAttributes, controller: OperandController) {
            $scope.operandIndex = parseInt(attrs["operandIndex"]);
            controller.setElement(element);
            $scope.allowableVariableTypes = controller.parseAllowableVariableTypes(attrs["allowableVariableTypes"]);
            $scope.allowTimeDurationUi = attrs["allowTimeDurationUi"] === "true";
            controller.compileOperandDirective($scope.getOperation().operands[$scope.operandIndex]);
        }
    }

    export class OperandController implements IController {
        private $scope: IOperandScope;
        private $compile: angular.ICompileService;
        private $http: ng.IHttpService;
        private $templateCache: ng.ITemplateCacheService;
        private element: JQuery;

        constructor(
            $scope: IOperandScope,
            $compile: ng.ICompileService,
            $http: ng.IHttpService,
            $templateCache: ng.ITemplateCacheService,
            private calculationService: services.CalculationService)
        {
            this.$scope = $scope;
            this.$compile = $compile;
            this.$http = $http;
            this.$templateCache = $templateCache;

            var self = this;

            $scope.$watch("getOperation().operands[operandIndex]", (newValue: Wars.Domain.Model.Calculations.Operand, oldValue: Wars.Domain.Model.Calculations.Operand) => {
                if (newValue === oldValue) {
                    return;
                }

                self.compileOperandDirective(this.$scope.getOperation().operands[this.$scope.operandIndex]);
            });

            $scope.$watch("getOperation().operands[operandIndex].treeItem_id", (newTreeItemId: string, oldFieldItemId: string) => {
                if (newTreeItemId !== oldFieldItemId) {
                    self.compileOperandDirective(self.$scope.getOperation().operands[this.$scope.operandIndex]);
                }
            });

            $scope.$watch("getOperation().operands[operandIndex].isATimeDurationInput", (newValue: string, oldValue: string) => {
                if (newValue !== oldValue) {
                    self.compileOperandDirective(self.$scope.getOperation().operands[this.$scope.operandIndex]);
                }
            });

            $scope.allowableOperandTypes = this.getAllowableOperandTypes();
        }

        public setElement(element: JQuery): void {
            this.element = element;
        }

        public parseAllowableVariableTypes(variableTypesString: string): Array<Wars.Domain.Model.Codes.Enums.VariableType> {
            var variableTypes = [];
            if (!variableTypesString || variableTypesString.length === 0) return variableTypes;

            var split = variableTypesString.split(",");

            for (var i = 0; i < split.length; i++) {
                var item = split[i];

                if (item === "String") variableTypes.push(Wars.Domain.Model.Codes.Enums.VariableType.String);
                else if (item === "Integer") variableTypes.push(Wars.Domain.Model.Codes.Enums.VariableType.Integer);
                else if (item === "Decimal") variableTypes.push(Wars.Domain.Model.Codes.Enums.VariableType.Decimal);
                else if (item === "DateTime") variableTypes.push(Wars.Domain.Model.Codes.Enums.VariableType.DateTime);
                else if (item === "Date") variableTypes.push(Wars.Domain.Model.Codes.Enums.VariableType.Date);
                else if (item === "Time") variableTypes.push(Wars.Domain.Model.Codes.Enums.VariableType.Time);
                else if (item === "TimeSpan") variableTypes.push(Wars.Domain.Model.Codes.Enums.VariableType.TimeSpan);
                else if (item === "TimeDuration") variableTypes.push(Wars.Domain.Model.Codes.Enums.VariableType.TimeDuration);
                else if (item === "Boolean") variableTypes.push(Wars.Domain.Model.Codes.Enums.VariableType.Boolean);
                else if (item === "List") variableTypes.push(Wars.Domain.Model.Codes.Enums.VariableType.List);
                else if (item === "Object") variableTypes.push(Wars.Domain.Model.Codes.Enums.VariableType.Object);
                else if (item === "Code") variableTypes.push(Wars.Domain.Model.Codes.Enums.VariableType.Code);
            }

            return variableTypes;
        }

        public compileOperandDirective(operand: Wars.Domain.Model.Calculations.Operand): void {
            var templateUrl: string;
            var htmlToAppend: any;
            var appendElement: any;

            if (operand.operandType === Wars.Domain.Model.Codes.Enums.OperandType.ComplexOperand) {
                templateUrl = './app/views/directives/calculate/complexOperandContent.html';
            }
            else if (operand.operandType === Wars.Domain.Model.Codes.Enums.OperandType.SimpleOperand) {
                let simpleOperand = <Wars.Domain.Model.Calculations.SimpleOperand>operand;

                if (simpleOperand.treeItem_id) {
                    var typedInConstant = this.calculationService.isTypedInConstant(simpleOperand.treeItem.constantValue);
                    if (!typedInConstant) {
                        templateUrl = './app/views/directives/calculate/simpleOperandContent.html';
                    }
                }
                if (simpleOperand.isATimeDurationInput) {
                    templateUrl = './app/views/directives/calculate/simpleOperandContent.html';
                }
            }
            if (!templateUrl) {
                templateUrl = './app/views/directives/calculate/operandDropZoneContent.html';
            }

            this.$http.get(templateUrl, { cache: this.$templateCache }).then((response: any) => {
                htmlToAppend = this.$compile(response.data)(this.$scope);
                appendElement = angular.element(this.element[0]);
                appendElement.empty();
                //TODO: somehow find scope of children and destroy to cleanup compiling's - e.g. scope.$destroy();
                appendElement.append(htmlToAppend);
            });
        }

        private getOperandInternal() : Wars.Domain.Model.Calculations.Operand {
            return this.$scope.getOperation().operands[this.$scope.operandIndex];
        }

        private operandDeletedInternal() {
            if (this.$scope.getOperation().operands[this.$scope.operandIndex].operandType === Wars.Domain.Model.Codes.Enums.OperandType.SimpleOperand) {
                var simpleOperand = <Wars.Domain.Model.Calculations.SimpleOperand>this.$scope.getOperation().operands[this.$scope.operandIndex];
                this.calculationService.deleteSimpleOperand(simpleOperand);
            } else if (this.$scope.getOperation().operands[this.$scope.operandIndex].operandType === Wars.Domain.Model.Codes.Enums.OperandType.ComplexOperand) {
                var complexOperand = <Wars.Domain.Model.Calculations.ComplexOperand>this.$scope.getOperation().operands[this.$scope.operandIndex];
                this.calculationService.deleteComplexOperand(complexOperand);
            }
            this.$scope.getOperation().operands[this.$scope.operandIndex] = undefined;
        }

        public getAllowableOperandTypes(): models.CalculationType[] {
            var valueOperator = this.$scope.getOperation().operator;
            var calculationType = this.calculationService.getCalculationTypeByValueOperation(valueOperator);
            return this.calculationService.getAllowableOperandTypes(calculationType);
        }
    }
}

warsApp.registerDirective('Operand', []);